import React, { useState, useEffect, useRef } from 'react';
import {
    Container,
    Typography,
    TextField,
    Button,
    Input,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@mui/material';
import axios from 'axios';

const EmailSender = ({ draft }) => {
    const [sender] = useState('abishek.cs21@bitsathy.ac.in'); // Superadmin's email
    const [recipient, setRecipient] = useState('');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [attachments, setAttachments] = useState([]);
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState('');
    const [sendMode, setSendMode] = useState('recipient'); // 'recipient', 'individual', or 'multiple'

    const fileInputRef = useRef(null); // Ref for file input

    useEffect(() => {
        if (draft) {
            setRecipient(draft.recipient || '');
            setSubject(draft.subject || '');
            setBody(draft.body || '');
            setAttachments(draft.attachments || []);
        } else {
            resetForm();
        }
    }, [draft]);

    const handleSendEmail = async () => {
        const formData = new FormData();
        formData.append('sender', sender);
        formData.append('subject', subject);
        formData.append('body', body);

        let endpoint = '';
        if (sendMode === 'recipient') {
            formData.append('recipient', recipient);
            endpoint = 'https://form.cpccbe.org/api/emails/send';
        } else if (sendMode === 'multiple') {
            formData.append('categories', JSON.stringify(categories));
            endpoint = 'https://form.cpccbe.org/api/emails/send-categories';
        } else if (sendMode === 'individual') {
            formData.append('category', category);
            endpoint = 'https://form.cpccbe.org/api/emails/send-category';
        }

        attachments.forEach((file) => {
            formData.append('attachments', file);
        });

        try {
            const response = await axios.post(endpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert(response.data.message || 'Emails sent successfully!');
            resetForm();
        } catch (error) {
            console.error('Error sending emails:', error);
            alert('Error sending emails. Please try again.');
        }
    };

    const handleSaveDraft = async () => {
        const draftData = {
            sender,
            recipient,
            subject,
            body,
            attachments,
            category,
            categories,
            sendMode,
        };
        console.log(draftData);
        try {
            const response = await axios.post(
                'https://form.cpccbe.org/api/emails/draft',
                draftData
            );
            console.log(response.data);
            alert(response.data.message);
        } catch (error) {
            console.error('Error saving draft:', error);
            alert('Error saving draft. Please try again.');
        }
    };

    const handleFileChange = (e) => {
        setAttachments(Array.from(e.target.files));
    };

    const resetForm = () => {
        setRecipient('');
        setSubject('');
        setBody('');
        setAttachments([]);
        setCategory('');
        setCategories([]);
        setSendMode('recipient');

        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const renderSendModeFields = () => {
        if (sendMode === 'recipient') {
            return (
                <TextField
                    label="Recipient Email"
                    value={recipient}
                    onChange={(e) => setRecipient(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                />
            );
        } if (sendMode === 'multiple') {
            return (
                <FormControl fullWidth margin="normal">
                    <InputLabel>Categories</InputLabel>
                    <Select
                        value={categories}
                        onChange={(e) => setCategories(e.target.value)}
                        multiple
                        renderValue={(selected) => selected.join(', ')}
                    >
                        <MenuItem value="individuals">Individuals</MenuItem>
                        <MenuItem value="industries">Industries</MenuItem>
                        <MenuItem value="institutions">Institutions</MenuItem>
                        <MenuItem value="associations">Associations</MenuItem>
                        <MenuItem value="tradeUnions">Trade Unions</MenuItem>
                        <MenuItem value="lifeMembers">Life Members</MenuItem>
                        <MenuItem value="students">Students</MenuItem>
                        <MenuItem value="seniorCitizens">Senior Citizens</MenuItem>
                        <MenuItem value="users">Users</MenuItem>
                    </Select>
                </FormControl>
            );
        } if (sendMode === 'individual') {
            return (
                <FormControl fullWidth margin="normal">
                    <InputLabel>Category</InputLabel>
                    <Select
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                    >
                        <MenuItem value="">Select Category</MenuItem>
                        <MenuItem value="individuals">Individuals</MenuItem>
                        <MenuItem value="industries">Industries</MenuItem>
                        <MenuItem value="institutions">Institutions</MenuItem>
                        <MenuItem value="associations">Associations</MenuItem>
                        <MenuItem value="tradeUnions">Trade Unions</MenuItem>
                        <MenuItem value="lifeMembers">Life Members</MenuItem>
                        <MenuItem value="students">Students</MenuItem>
                        <MenuItem value="seniorCitizens">Senior Citizens</MenuItem>
                        <MenuItem value="users">Users</MenuItem>
                    </Select>
                </FormControl>
            );
        }
    };

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Compose Email
            </Typography>

            {/* Toggle between recipient, individual, and multiple categories */}
            <FormControl component="fieldset">
                <RadioGroup
                    row
                    value={sendMode}
                    onChange={(e) => setSendMode(e.target.value)}
                >
                    <FormControlLabel
                        value="recipient"
                        control={<Radio />}
                        label="Send to Specific Recipient"
                    />
                    <FormControlLabel
                        value="individual"
                        control={<Radio />}
                        label="Send to Individual Category"
                    />
                    <FormControlLabel
                        value="multiple"
                        control={<Radio />}
                        label="Send to Multiple Categories"
                    />
                </RadioGroup>
            </FormControl>

            {renderSendModeFields()}

            <TextField
                label="Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                fullWidth
                margin="normal"
                required
            />
            <TextField
                label="Message"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={4}
                required
            />
            <Input type="file" multiple onChange={handleFileChange} ref={fileInputRef} />
            <br />
            <br />
            <Button
                variant="contained"
                color="primary"
                onClick={handleSendEmail}
            >
                Send Email
            </Button>
            <Button
                variant="contained"
                color="secondary"
                onClick={handleSaveDraft}
                style={{ marginLeft: '10px' }}
            >
                Save Draft
            </Button>
        </Container>
    );
};

export default EmailSender;
